import React, { useState, useEffect, useContext } from 'react';
import {Stack, Card, Button} from '@shopify/polaris';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import EditCourseTreeForm from './EditCourseTreeForm'
import { CourseTreeContext } from '../contexts/CourseTree'
import EditContainer from './EditContainer'
import EditContent from './EditContent'

export default function EditCourseTree(props) {
  const [courseTree, updateCourseTree, isOpen, toggleOpen] = useContext(CourseTreeContext)

  const onAddNode = (node) => {
    courseTree.addNode(courseTree, node, node.position)
    updateCourseTree(courseTree)
  }

  return (
    <DndProvider backend={HTML5Backend}>
    <Card>
      <Card.Header title={courseTree.course.name}>
        <EditContainer
          onSave={onAddNode}
          title="Add container"
          item={{
            parent_node_id: courseTree.id,
            parent_node_type: 'CourseTree',
            position: courseTree.child_nodes && courseTree.child_nodes.length || 0,
            course_tree_id: courseTree.id
          }}
        />
        <EditContent
          onSave={onAddNode}
          title="Add content"
          item={{
            parent_node_id: courseTree.id,
            parent_node_type: 'CourseTree',
            position: courseTree.child_nodes && courseTree.child_nodes.length || 0,
            course_tree_id: courseTree.id
          }}
        />
        <Button plain onClick={() => { props.onEditing && props.onEditing(false) }}>Close</Button>
      </Card.Header>
      <Card.Section>
        <EditCourseTreeForm />
      </Card.Section>
    </Card></DndProvider>
  );
}
